import { useTheme } from '@mui/material';
import { useConfig } from '../../../Hooks/useConfig';
import { useTranslation } from 'react-i18next';
import AIButton from '../../Button/AIButton';

const LoginButton = ({
  extrnalLink = false,
  showIcon = true,
  sx = {},
  isCollapsed = false,
}) => {
  const { panelUrl, playgroundUrl } = useConfig();
  const theme = useTheme();

  return (
    <AIButton
      link={!extrnalLink}
      to={!extrnalLink ? '/login' : ''}
      href={extrnalLink ? `${playgroundUrl}/login` : ''}
      width={isCollapsed ? 'auto' : 'full'}
      type="copy"
      isCollapsed={isCollapsed}
      sx={{
        fontSize: {
          xs: `${theme.spacing(4)} !important`,
          md: `${theme.spacing(3)} !important`,
          lg: `${theme.spacing(3.5)} !important`,
          xl: `${theme.spacing(4)} !important`,
        },
        padding: isCollapsed ? theme.spacing(3, 0) : theme.spacing(3, 4),
        minWidth: isCollapsed ? '40px' : undefined,
        marginLeft: isCollapsed ? theme.spacing(2) : 0,
        [theme.breakpoints.up('xl')]: {
          padding: isCollapsed ? theme.spacing(3, 0) : theme.spacing(3, 4),
        },
        [theme.breakpoints.down('md')]: {
          padding: theme.spacing(2, 2),
        },
        [theme.breakpoints.down('420')]: {
          padding: theme.spacing(1.5, 2),
        },
        ...sx,
      }}
      // theme="ocean"
    >
      {showIcon ? 'Login' : null}
    </AIButton>
  );
};

export default LoginButton;
